<template>
    <div class="card" v-bind:class="[question.type]">
        <div class="card-header" :id="'header-'+step+'Question'+question.id" data-toggle="collapse"
             :data-target="'#collapseStep'+step+'Question'+question.id"
             v-bind:aria-expanded="question.openByDefault ? 'true' : 'false'"
             aria-controls="collapseOne"
             :class="{'answered' : showSpoiler!==false}"
        >
            <h5 class="mb-0">
                <button class="btn btn-link">
                    {{question.label}}
                </button>
                <div class="recap limit-length" v-show="showSpoiler != false">
                    <span>{{strip(showSpoiler)}}</span>
                </div>
            </h5>
        </div>
        <div :id="'collapseStep'+step+'Question'+question.id" class="collapse"
             v-bind:class="{show : question.openByDefault}"
             :aria-labelledby="'collapseStep'+step+'Question'+question.id" data-parent="#main-form">
            <label v-if="question.placeholder">{{ question.placeholder }}</label>

            <div v-if="question.extraHtml !== undefined && question.extraHtml.content_top !== null !== undefined && question.extraHtml.content_top !== null"
                 v-html="question.extraHtml.content_top"></div>
            <div class="card-body">
                <div v-for="(answer, answerKey) in question.answers" class="checkbox-choice"
                     v-bind:class="{ 'selected' : answer.label == showSpoiler }"
                     v-on:click="addToAnswers(answerKey)"
                     v-html="answer.label"
                >

                </div>

            </div>
            <div class="center-content"
                 v-if="question.extraHtml !== undefined && question.extraHtml.content_bottom !== null !== undefined && question.extraHtml.content_bottom !== null"
                 v-html="question.extraHtml.content_bottom"></div>

            <button v-if="question.popup !== undefined && question.popup !== ''" type="button" class="open-modal"
                    data-toggle="modal" @click="fillAndOpenDefaultModal()">
                {{question.popupLabel}}
            </button>
        </div>


    </div>
</template>

<script>
    import common from './mixins/common'

    export default {
        name: "TextRadioChoice",

        props: {
            question: Object,
            questions: Object,
            step: [String, Number]
        },

        mixins: [common],

        data: function () {
            return {
                showSpoiler: false
            }
        },

        methods: {
            strip: function (html) {
                let doc = new DOMParser().parseFromString(html, 'text/html');
                return doc.body.textContent || "";
            },
            fillAndOpenDefaultModal() {

                let modal = $('#basicModal');
                modal.find('h5').text(this.question.popupLabel);
                modal.find('img').attr('src', this.question.popup);
                modal.find('.extra-popup').html('')
                modal.modal('show');

            },
            addToAnswers: function (answerIndex) {
                const questionIndex = this.question.id;

                Object.keys(this.questions[questionIndex].answers).forEach((key) => {
                    this.questions[questionIndex].answers[key].isAnswer = false;
                });

                const answer = this.questions[questionIndex].answers[answerIndex];
                answer.isAnswer = true;
                this.showSpoiler = answer.label;
                this.$store.dispatch('addAnswersThenCalc', {
                    isGlobal: this.question.global !== undefined && this.question.global,
                    name: this.questions[questionIndex].label,
                    stepIndex: this.step,
                    questionIndex: questionIndex,
                    questionType: this.questions[questionIndex].type,
                    effectOnSvg: this.questions[questionIndex].effectOnSvg,
                    index: 0,
                    label: answer.label,
                    value: answer.isAnswer ? answer.value : null,
                    variable: this.questions[questionIndex].variable || null,
                    changes: answer.changes !== undefined ? answer.changes : null,
                });

                this.openNextQuestion(this.step, this.questions[questionIndex].id, this);
            },

            initialize() {
                if (this.answers[this.step] && this.answers[this.step][this.question.id]) {
                    const answers = this.answers[this.step][this.question.id];

                    Object.keys(answers).forEach((idx) => {
                        answers[idx].isAnswer = true;

                        this.showSpoiler = answers[idx].label || this.showSpoiler;
                    });
                }
            },
        }
    }
</script>

<style scoped>
    .card-body {
        justify-content: space-around;
    }

    .center-content {
        display: flex;
        justify-content: center;
        min-height: 100px;
    }

    .checkbox-choice {
        cursor: pointer;
        padding: 20px;
        border: 1px solid #ccc;
        margin-bottom: 10px;
        border-radius: 3px;
    }

    .checkbox-choice:hover {
        background-color: #fafafa;
    }

    .checkbox-choice.selected {
        background-color: #fafafa;
        cursor: default;
    }

    label {
        margin-top: 25px;
    }

    @media screen and (max-width: 767px) {
        .checkbox-choice {
            margin-bottom: 30px;
            width: 40%;
        }
    }

    .recap.limit-length span {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        max-width: 200px;
        display: block;
    }

    @media screen and (max-width: 1024px) {
        h5 .recap {
            display: none;
        }
    }

    .open-modal {
        margin-bottom: 20px;
        padding: 12px;
        /* background: #c4c4c4 !important; */
        color: #2d2d2d;
    }
</style>
